// frontend/src/components/cash-close/AdaptiveVarianceTable.js
import React, { useState } from 'react';
import VarianceTableDetail from './VarianceTableDetail';
import VarianceTableCompact from './VarianceTableCompact';
import VarianceTableWideGrid from './VarianceTableWideGrid';

export default function AdaptiveVarianceTable({
  rows, months, selectedMonth, currency, fxRate, priorMonthSummary, drilldownRenderer, commentary,
}) {
  const [expandedDept, setExpandedDept] = useState(null);
  const [expandedCell, setExpandedCell] = useState(null);
  const [showNumbers, setShowNumbers] = useState(false);

  const handleCellClick = (dept, month) => {
    setExpandedCell(prev => prev?.dept === dept && prev?.month === month ? null : { dept, month });
    setExpandedDept(prev => prev === dept ? null : dept);
  };

  if (months.length === 1) {
    return (
      <VarianceTableDetail
        rows={rows} priorMonthSummary={priorMonthSummary}
        currency={currency} fxRate={fxRate}
        onCellClick={handleCellClick}
        expandedDept={expandedDept}
        drilldownRenderer={drilldownRenderer}
        commentary={commentary}
      />
    );
  }
  if (months.length >= 2 && months.length <= 4) {
    return (
      <VarianceTableCompact
        rows={rows} selectedMonth={selectedMonth} currency={currency} fxRate={fxRate}
        onCellClick={handleCellClick}
        expandedCell={expandedCell}
        drilldownRenderer={drilldownRenderer}
        commentary={commentary}
      />
    );
  }
  return (
    <VarianceTableWideGrid
      rows={rows} selectedMonth={selectedMonth} currency={currency} fxRate={fxRate}
      drilldownRenderer={drilldownRenderer}
      commentary={commentary}
      showNumbers={showNumbers}
      onToggleNumbers={() => setShowNumbers(s => !s)}
    />
  );
}
